import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import AlertifyHelper from 'src/app/utils/utils';
import { OpeningService } from 'src/app/api/money/opening.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import { IncomeService } from 'src/app/api/money/income.service';
import SwalAlert from 'src/app/utils/swalalert';
import { HttpHeaders } from '@angular/common/http';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { finalize } from 'rxjs';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { SearchProductComponent } from 'src/app/components/search-product/search-product.component';
declare var $: any;

@Component({
  selector: 'app-amortization-extends',
  templateUrl: './amortization-extends.component.html',
  styleUrls: ['./amortization-extends.component.css']
})
export class AmortizationExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(SearchProductComponent) SearchProductComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;

  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;
  isRuc: boolean = false;
  isEdit: boolean = false;
  sizeModal: string = 'modal-lg';
  module: any = null;

  // variables
  company: any = null;
  branchoffices: any = [];
  branchOfficeSelected: any = null;
  book: any = null;
  check_moneybox: boolean = false;
  boxselected: any = null;
  moneybox: any = null;
  validatealert: boolean = false;

  currencies: any = [];
  paymentmethods: any = [];
  accountbanks: any = [];
  typevouchers: any = [];
  series: any = [];

  // for billing data
  OtherClient: boolean = false;
  isClientSelected: boolean = false;
  clientSelected: any = {};

  // for detail services
  detailService: boolean = false;
  isServiceSelected: boolean = false;
  serviceSelected: any = {};
  service_data: any = {
    product_id: null,
    is_detail_service: false,
    text_detail_service: null
  };

  userpositions: any = constants.USER.TYPES;
  user_client: any = constants.USER.TYPES[0];
  user_provider: any = constants.USER.TYPES[1];
  positionSelected: any = this.user_client.id;
  isPositionSelected: boolean = false;
  possitionValue: any = {};
  paymentMethodSelected: any = {};
  fileUrlImage: any = null;

  amount: any = 0;
  amount_last: any;
  amount_paid: any = 0;

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_recibo: any = null;
  typedocument_ruc: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private openingService: OpeningService,
    private incomeService: IncomeService,
    private generalService: GeneralService,
    private accountbankService: AccountbankService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private amountTextService: AmountTextService,
    private alert: SwalAlert
  ) {
    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_recibo = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

    this.typedocument_ruc = constants.CLIENT.TYPE_DOCUMENT.RUC;

    this.item = this.fb.group({
      currency_id: [null, [Validators.required]],
      paymentmethod_id: [
        constants.paymentmethod_init_id,
        [Validators.required]
      ],
      accountbank_id: [null],
      gloss: [null],
      amount: [null],
      reference_operation: [null],
      text_amount: [null],
      observation: [null],
      //variables from boook ======
      client_id: [null],
      booking_id: [null],
      branchoffice_id: [null],
      typevoucher_id: [null],
      serie: [null]
    });
  }

  init(book: any, module:any) {
    // valor inicial
    this.book = null;
    this.company = null;
    this.module = module;
    // resetear valores

    this.book = book;
    this.company = book.company;
    if (this.company.send_billing) {
      this.sizeModal = 'modal-xl';
      this.branchoffices = book.company.branchoffices;
      this.branchOfficeSelected = this.branchoffices[0];
      this.item.patchValue({
        branchoffice_id: this.branchOfficeSelected.id
      });
    }
    this.amount_paid = this.book.total - this.book.total_paid;
    let label = '';
    if (this.book.reference_voucher != null) {
      label = '- REF: ' + this.book.reference_voucher;
    }
    let gloss_val = 'COD: ' + this.book.code + label;

    this.item.patchValue({
      amount: 0,
      client_id: this.book.client_id,
      booking_id: this.book.id,
      gloss: gloss_val
    });

    this.checkBoxSelected();
    // this.getTypeVoucherBooking();
    // this.getCurrencies();
    // this.getAccountBanks();
    // this.getPaymentmethods();
    if (this.book != null) {
      setTimeout(() => {
        this.LoadingModalComponent.show();
      }, 50);
    }
    this.loadInitialData();
  }

  loadInitialData() {
    forkJoin({
      // typeVouchers: this.generalService.listTypeVoucherBooking(),
      currencies: this.generalService.listCurrencies(),
      paymentMethods: this.generalService.listPaymentmethods(),
      accountBanks: this.accountbankService.all()
    })
      .pipe(
        finalize(() => {
          this.LoadingModalComponent.hide(); // ✅ Se ejecuta DESPUÉS de que todo haya terminado
        })
      )
      .subscribe({
        // next: ({ typeVouchers, currencies, paymentMethods, accountBanks }) => {
        next: ({ currencies, paymentMethods, accountBanks }) => {
          // ✅ Asignar datos recibidos
          // this.typevouchers = typeVouchers.results;
          this.currencies = currencies.results;
          this.paymentmethods = paymentMethods.results;
          this.accountbanks = accountBanks.results;
          this.getTypeVoucherBooking();

          // ✅ Establecer valores iniciales en el formulario
          // if (!this.company.send_billing) {
          //   this.item.patchValue({
          //     typevoucher_id: this.typevoucher_recibo.id
          //   });
          // } else {
          //   if (this.typevouchers.length) {
          //     this.item.patchValue({ typevoucher_id: this.typevouchers[0].id });
          //   }
          // }
          // this.getSerieVoucher(this.typevouchers[0].id);

          const principalCurrency = this.currencies.find(
            (c: { is_principal: any }) => c.is_principal
          );
          if (principalCurrency) {
            this.item.patchValue({ currency_id: principalCurrency.id });
          }

          this.changePaymentMethod(); // Si necesitas hacer algo con los métodos de pago
        },
        error: err => {
          console.error('Error cargando datos:', err);
          this.LoadingModalComponent.hide(); // Desactivamos el loading en caso de error
        }
      });
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {
        if (!_.isNull(data.data)) {
          this.boxselected = data.data;
          this.getBoxOpening();
        }
      }
    });
  }

  getBoxOpening() {
    this.openingService.getBoxOpening(this.boxselected.id).subscribe({
      next: (data: any) => {
        this.validatealert = true;
        if (data.data) {
          this.check_moneybox = true;
          this.moneybox = data.data;
        }
      }
    });
  }

  changeOffice() {
    let id_office_ = this.item.value.branchoffice_id;
    this.branchOfficeSelected = this.toolsService.searchObjById(
      id_office_,
      this.branchoffices
    );
    this.item.patchValue({ typevoucher_id: this.typevouchers[0].id });
    let typevoucher_id = this.item.value.typevoucher_id;
    // this.getSerieVoucher(typevoucher_id);
    this.getTypeVoucherBooking();
  }

  getTypeVoucherBooking() {
    this.LoadingModalComponent.show();
    if (this.branchOfficeSelected == null) {
      this.generalService.listTypeVoucherBooking().subscribe({
        next: (data: any) => {
          this.typevouchers = data.results;
          this.item.patchValue({
            typevoucher_id: this.typevouchers[0].id
          });
          this.getSerieVoucher(this.typevouchers[0].id);
        }
      });
    } else {
      let params = 'branchoffice_id=' + this.branchOfficeSelected.id;
      this.generalService.listTypeVoucherBookingByOffice(params).subscribe({
        next: (data: any) => {
          this.typevouchers = data.results;
          this.item.patchValue({
            typevoucher_id: this.typevouchers[0].id
          });
          this.getSerieVoucher(this.typevouchers[0].id);
        }
      });
    }
  }

  getSerieVoucher(typevoucher_id: any) {
    this.LoadingModalComponent.show();
    if (this.company.billing_by_branch) {
      let params =
        'typevoucher_id=' +
        typevoucher_id +
        '&branchoffice_id=' +
        this.branchOfficeSelected.id;
      this.generalService.getByVoucherAndBranchOffice(params).subscribe({
        next: (data: any) => {
          this.series = data.results;
          if (this.series.length > 0) {
            this.item.patchValue({
              serie: this.series[0].series
            });
          } else {
            this.alertifyMsg.error(
              'NO SE ENCONTRARON SERIES PARA EL TIPO DE COMPROBANTE, consulte a su administrador de sistemas'
            );
          }
          this.LoadingModalComponent.hide();
        }
      });
    } else {
      this.generalService.getSerieTypeVoucher(typevoucher_id).subscribe({
        next: (data: any) => {
          this.series = data.results;
          this.item.patchValue({
            serie: this.series[0].series
          });
          this.LoadingModalComponent.hide();
        }
      });
    }
  }

  changeTypeVoucher() {
    let typevoucher_id = this.item.value.typevoucher_id;
    this.isRuc = false;
    if (this.item.value.typevoucher_id == this.typevoucher_factura.id) {
      this.isRuc = true;
    }
    if (typevoucher_id == this.typevoucher_recibo.id) {
      this.service_data.is_detail_service = false;
      this.service_data.text_detail_service = null;
      this.service_data.product_id = null;
      this.detailService = false;
      this.isServiceSelected = false;
      this.serviceSelected = null;
    }
    this.getSerieVoucher(typevoucher_id);
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
          }
        }
      }
    });
  }

  getPaymentmethods() {
    this.generalService.listPaymentmethods().subscribe({
      next: (data: any) => {
        this.paymentmethods = data.results;
        this.changePaymentMethod();
      }
    });
  }

  changePaymentMethod() {
    let obj_ = this.toolsService.searchArrById(
      this.item.value.paymentmethod_id,
      this.paymentmethods
    );
    this.paymentMethodSelected = obj_;

    if (!this.paymentMethodSelected.associate_bank) {
      this.item.patchValue({
        accountbank_id: null,
        reference_operation: null
      });
    }
  }

  getAccountBanks() {
    this.accountbankService.all().subscribe({
      next: (data: any) => {
        this.accountbanks = data.results;
      }
    });
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.item.patchValue({
      accountbank_id: value_
    });
  }

  calculate_difference() {
    setTimeout(() => {
      let paid = Number(this.book.total) - Number(this.book.total_paid);
      if (Number(this.item.value.amount) > paid) {
        this.alertifyMsg.warning(
          'El monto no puede ser mayor a la deuda total!'
        );
        this.item.patchValue({
          amount: 0
        });
      } else {
        this.amount_paid = (
          Number(paid) - Number(this.item.value.amount)
        ).toFixed(2);
      }
    }, 250);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
    }
  }

  changeOtherClient() {
    if (this.OtherClient) {
      this.item.patchValue({
        client_id: null
      });
      setTimeout(() => {
        this.SearchClientComponent.focused();
      }, 150);
    } else {
      this.item.patchValue({
        client_id: this.book.client_id
      });
    }
  }

  selectedClientSearch(item_: any) {
    this.isClientSelected = true;
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id
    });
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  removeClient() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  changeDetailService() {
    if (this.detailService) {
      setTimeout(() => {
        (<any>$('#text_detail_service')).focus();
      }, 150);
    } else {
      this.service_data.text_detail_service = null;
      (<any>$('#text_detail_service')).val('null');
      setTimeout(() => {
        this.SearchProductComponent.focused();
      }, 150);
    }
  }

  selectedServiceSearch(item_: any) {
    this.isServiceSelected = true;
    this.serviceSelected = item_;
    this.service_data.product_id = item_.id;
  }

  removeService() {
    this.isServiceSelected = false;
    this.serviceSelected = {};
    this.service_data.product_id = null;
    setTimeout(() => {
      this.SearchProductComponent.focused();
    }, 150);
  }

  convertToUppercase() {
    this.service_data.text_detail_service = this.service_data.text_detail_service.toUpperCase();
  }

  preSave() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let options = {
        title: '¡Atención!',
        message:
          '¿Esta seguro(a) de registrar la amortización de la reserva ' +
          this.book.code +
          '?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    let data: any = {};
    this.item.patchValue({
      text_amount: this.amountTextService.letras(this.item.value.amount)
    });
    this.service_data.is_detail_service = this.detailService;
    data.income = this.item.value;
    this.LoadingModalComponent.show();

    const formData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    formData.append('module', this.module);
    formData.append('item', JSON.stringify(data));
    formData.append('service_data', JSON.stringify(this.service_data));
    formData.append('url_image', this.fileUrlImage);

    if (!this.isEdit) {
      this.incomeService.saveAmortizationExtends(formData).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro realizado con éxito');
          (<any>$('#openExtendsAmortization')).modal('hide');
          this.close();
          this.onSubmitEvent.emit(data);
          this.LoadingModalComponent.hide();
        },
        error: (err: any) => {
          console.error('Error:', err); // Muestra detalles del error en la consola
          this.LoadingModalComponent.hide();
        }
      });
    }
  }

  validate() {
    if (this.company.send_billing) {
      if (this.OtherClient) {
        if (this.item.value.client_id == null) {
          this.alertifyMsg.warning(
            'Debe especificar el cliente del comprobante'
          );
          this.SearchClientComponent.focused();
          return false;
        }
      }

      if (this.isRuc) {
        if (!this.isClientSelected) {
          this.alertifyMsg.warning(
            'Debe especificar el cliente con RUC para el comprobante'
          );
          return false;
        } else {
          if (this.clientSelected.typedocument_id != this.typedocument_ruc.id) {
            this.alertifyMsg.warning(
              'El cliente seleccionado DEBE SER CON TIPO DOCUMENTO RUC'
            );
            return false;
          }
        }
      }

      if (this.item.value.typevoucher_id != this.typevoucher_recibo.id) {
        if (this.detailService) {
          if (this.service_data.text_detail_service == null) {
            this.alertifyMsg.warning(
              'Debe especificar el detalle del servicio asociado al comprobante'
            );
            (<any>$('#text_detail_service')).focus();
            return false;
          }
        } else {
          if (this.service_data.product_id == null) {
            this.alertifyMsg.warning(
              'Debe especificar el servicio asociado al comprobante'
            );
            this.SearchProductComponent.focused();
            return false;
          }
        }
      }
    }

    if (_.isNull(this.item.value.amount) || _.isEmpty(this.item.value.amount)) {
      this.alertifyMsg.warning(
        'El monto a pagar no puede ser igual a cero o estar vacío'
      );
      (<any>$('#amount_paid')).focus();
      return false;
    }
    if (this.item.value.amount == 0) {
      this.alertifyMsg.warning('El monto a pagar no puede ser igual a cero');
      (<any>$('#amount_paid')).focus();
      return false;
    }

    return true;
  }

  close() {
    this.isEdit = false;
    this.OtherClient = false;
    this.paymentmethods = [];
    this.currencies = [];
    this.typevouchers = [];
    this.series = [];
    this.service_data.product_id = null;
    this.service_data.is_detail_service = false;
    this.service_data.text_detail_service = null;
    this.isClientSelected = false;
    this.isServiceSelected = false;
    this.clientSelected = null;
    this.serviceSelected = null;
    this.isRuc = false;
    this.detailService = false;
    this.item.patchValue({
      amount: 0,
      gloss: null,
      client_id: null,
      booking_id: null,
      paymentmethod_id: constants.paymentmethod_init_id
    });

    (<any>$('#fileUrlImage')).val('');
    this.fileUrlImage = null;
  }
}
